import { makeStyles } from "@material-ui/core/styles";
import { transparentize } from "polished";
import { secondary } from "../../../infrastructure/theme/customColors";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  cell: {
    height: 48,
    fontSize: theme.spacing(1.5),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    whiteSpace: "normal",
    wordWrap: "break-word",
  },
  checkedRow: {
    backgroundColor: transparentize(0.9, secondary),
  },
}));

export default useStyles;
